import TenKrona from '@tradera/tradera-ui/icons/10kr.svg?jsx';
import LastChance from '@tradera/tradera-ui/icons/last-chance.svg?jsx';
import ForYou from '@tradera/tradera-ui/icons/for-you.svg?jsx';

export default [
    {
        url: '/campaign/under10',
        text: 'Under 10 kr',
        icon: TenKrona,
        image: require('static/images/category-carousel/10kr.jpg')
    },
    {
        url: '/ma/endless-recommendation',
        text: 'Bara för dig',
        icon: ForYou,
        image: require('static/images/category-carousel/picksforyou.jpg')
    },
    {
        url: '/campaign/sista-chansen',
        text: 'Sista chansen',
        icon: LastChance,
        image: require('static/images/category-carousel/lastchance.jpg')
    },
    {
        url: '/accessoarer-1612',
        text: 'Accessoarer',
        image: require('static/images/category-carousel/accessoarer.jpg')
    },
    {
        url: '/antikt-design-20',
        text: 'Antikt & Design',
        image: require('static/images/category-carousel/antikt-design.jpg')
    },
    {
        url: '/barnklader-barnskor-33',
        text: 'Barnkläder & barnskor',
        image: require('static/images/category-carousel/barnklader-barnskor.jpg')
    },
    {
        url: '/biljetter-resor-34',
        text: 'Biljetter & Resor',
        image: require('static/images/category-carousel/biljetter-resor.jpg')
    },
    {
        url: '/bygg-verktyg-32',
        text: 'Bygg & Verktyg',
        image: require('static/images/category-carousel/bygg-verktyg.jpg')
    },
    {
        url: '/bocker-tidningar-11',
        text: 'Böcker & Tidningar',
        image: require('static/images/category-carousel/bocker-tidningar.jpg')
    },
    {
        url: '/datorer-tillbehor-12',
        text: 'Datorer & Tillbehör',
        image: require('static/images/category-carousel/datorer-tillbehor.jpg')
    },
    {
        url: '/dvd-videofilmer-13',
        text: 'DVD & Videofilmer',
        image: require('static/images/category-carousel/dvd-videofilmer.jpg')
    },
    {
        url: '/fordon-batar-delar-10',
        text: 'Fordon,Båtar & Delar',
        image: require('static/images/category-carousel/fordon-batar-delar.jpg')
    },
    {
        url: '/kameror-optik-14',
        text: 'Foto, Kameror & Optik',
        image: require('static/images/category-carousel/kameror-optik.jpg')
    },
    {
        url: '/frimarken-15',
        text: 'Frimärken',
        image: require('static/images/category-carousel/frimarken.jpg')
    },
    {
        url: '/hem-hushall-31',
        text: 'Hem & Hushåll',
        image: require('static/images/category-carousel/hem-hushall.jpg')
    },
    {
        url: '/hemelektronik-17',
        text: 'Hemelektronik',
        image: require('static/images/category-carousel/hemelektronik.jpg')
    },
    {
        url: '/hobby-18',
        text: 'Hobby',
        image: require('static/images/category-carousel/hobby.jpg')
    },
    {
        url: '/klockor-19',
        text: 'Klockor',
        image: require('static/images/category-carousel/klockor.jpg')
    },
    {
        url: '/klader-16',
        text: 'Kläder',
        image: require('static/images/category-carousel/klader.jpg')
    },
    {
        url: '/konst-23',
        text: 'Konst',
        image: require('static/images/category-carousel/konst.jpg')
    },
    {
        url: '/leksaker-343319',
        text: 'Leksaker & Barnartiklar',
        image: require('static/images/category-carousel/leksaker.jpg')
    },
    {
        url: '/mobiltelefoni-26',
        text: 'Mobiltelefoni & Tele',
        image: require('static/images/category-carousel/mobiltelefoni.jpg')
    },
    {
        url: '/musik-21',
        text: 'Musik',
        image: require('static/images/category-carousel/musik.jpg')
    },
    {
        url: '/mynt-sedlar-22',
        text: 'Mynt & Sedlar',
        image: require('static/images/category-carousel/mynt-sedlar.jpg')
    },
    {
        url: '/samlarsaker-29',
        text: 'Samlarsaker',
        image: require('static/images/category-carousel/samlarsaker.jpg')
    },
    {
        url: '/skor-1623',
        text: 'Skor',
        image: require('static/images/category-carousel/skor.jpg')
    },
    {
        url: '/skonhetsvard-340736',
        text: 'Skönhetsvård',
        image: require('static/images/category-carousel/skonhetsvard.jpg')
    },
    {
        url: '/smycken-adelstenar-24',
        text: 'Smycken & ädelstenar',
        image: require('static/images/category-carousel/smycken-adelstenar.jpg')
    },
    {
        url: '/sport-fritid-25',
        text: 'Sport & Fritid',
        image: require('static/images/category-carousel/sport-fritid.jpg')
    },
    {
        url: '/tv-spel-datorspel-30',
        text: 'TV-Spel & Datorspel',
        image: require('static/images/category-carousel/tv-spel-datorspel.jpg')
    },
    {
        url: '/vykort-bilder-27',
        text: 'Vykort & Bilder',
        image: require('static/images/category-carousel/vykort-bilder.jpg')
    },
    {
        url: '/ovrigt-28',
        text: 'Ovrigt',
        image: require('static/images/category-carousel/ovrigt.jpg')
    }
];



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/start-page/data.js